import { MapLocation } from '@/types/location';

export const jeddahSchools: MapLocation[] = [
  {
    id: 70001,
    name: "Alanjal (Rawdah)",
    type: "School",
    devices: 2,
    coordinates: [21.5753394, 39.0718579],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 555
    }
  },
  {
    id: 70002,
    name: "Rowad Alkhaleej (Obhur)",
    type: "School",
    devices: 4,
    coordinates: [21.7645505, 39.0885646],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 851
    }
  },
  {
    id: 70003,
    name: "Al Thuraya Model Schools (Murjan)",
    type: "School",
    devices: 2,
    coordinates: [21.68396, 39.10743],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "3-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Kindergarten, Elementary, Intermediate",
      students: 299
    }
  },
  // Alandalus (Ashati) - schools
  {
    id: 70004,
    name: "Alandalus (Ashati) - Elementary Male",
    type: "School",
    devices: 1,
    coordinates: [21.6116371, 39.1140348],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 132
    }
  },
  {
    id: 70005,
    name: "Alandalus (Ashati) - Intermediate Male",
    type: "School",
    devices: 1,
    coordinates: [21.6116371, 39.1140348],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate",
      students: 80
    }
  },
  {
    id: 70006,
    name: "Alandalus (Ashati) - Elementary Female",
    type: "School",
    devices: 1,
    coordinates: [21.6116371, 39.1140348],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 172
    }
  },
  {
    id: 70007,
    name: "Alandalus (Ashati) - Intermediate Female",
    type: "School",
    devices: 1,
    coordinates: [21.6116371, 39.1140348],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate",
      students: 127
    }
  },
  {
    id: 70008,
    name: "Alandalus (Ashati) - Secondary Female",
    type: "School",
    devices: 2,
    coordinates: [21.6116371, 39.1140348],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "15-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Secondary",
      students: 172
    }
  },
  {
    id: 70009,
    name: "Alandalus (Ashati) - International Elementary Female",
    type: "School",
    devices: 3,
    coordinates: [21.6121906, 39.1154914],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 721
    }
  },
  {
    id: 70010,
    name: "Alandalus (Ashati) - International Intermediate Female",
    type: "School",
    devices: 1,
    coordinates: [21.6121906, 39.1154914],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate",
      students: 280
    }
  },
  {
    id: 70011,
    name: "Alandalus (Ashati) - International Elementary Male",
    type: "School",
    devices: 1,
    coordinates: [21.6121906, 39.1154914],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 278
    }
  },
  {
    id: 70012,
    name: "Alandalus (Ashati) - International Intermediate/Secondary Male",
    type: "School",
    devices: 1,
    coordinates: [21.6121906, 39.1154914],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate, Secondary",
      students: 155
    }
  },
  // Alandalus (Rawdah) - schools
  {
    id: 70013,
    name: "Alandalus (Rawdah) - Elementary Male",
    type: "School",
    devices: 3,
    coordinates: [21.5669005, 39.1461597],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 268
    }
  },
  {
    id: 70014,
    name: "Alandalus (Rawdah) - Intermediate Male",
    type: "School",
    devices: 2,
    coordinates: [21.5669005, 39.1461597],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate",
      students: 217
    }
  },
  {
    id: 70015,
    name: "Alandalus (Rawdah) - Secondary Male",
    type: "School",
    devices: 1,
    coordinates: [21.5669005, 39.1461597],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Secondary",
      students: 135
    }
  },
  // Alandalus (Fayhaa) - schools
  {
    id: 70016,
    name: "Alandalus (Fayhaa) - Elementary Female",
    type: "School",
    devices: 1,
    coordinates: [21.5066384, 39.2030167],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary",
      students: 195
    }
  },
  {
    id: 70017,
    name: "Alandalus (Fayhaa) - Intermediate Female",
    type: "School",
    devices: 1,
    coordinates: [21.5066384, 39.2030167],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate",
      students: 51
    }
  },
  {
    id: 70018,
    name: "Alandalus (Fayhaa) - Elementary/Intermediate Male",
    type: "School",
    devices: 1,
    coordinates: [21.5066384, 39.2030167],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary, Intermediate",
      students: 195
    }
  },
  {
    id: 70019,
    name: "Alandalus (Fayhaa) - International Elementary Female",
    type: "School",
    devices: 1,
    coordinates: [21.5066384, 39.2030167],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 282
    }
  },
  {
    id: 70020,
    name: "Alandalus (Fayhaa) - International Intermediate Female",
    type: "School",
    devices: 1,
    coordinates: [21.5066384, 39.2030167],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-15",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate",
      students: 58
    }
  },
  // Advanced Generations Schools (Nahdah)
  {
    id: 70021,
    name: "Advanced Generations Schools (Nahdah) - Elementary Male",
    type: "School",
    devices: 2,
    coordinates: [21.6287162, 39.1232621],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 626
    }
  },
  {
    id: 70022,
    name: "Advanced Generations Schools (Nahdah) - Intermediate/Secondary Male",
    type: "School",
    devices: 3,
    coordinates: [21.6287162, 39.1232621],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate, Secondary",
      students: 325
    }
  },
  {
    id: 70023,
    name: "Advanced Generations Schools (Nahdah) - Elementary Female",
    type: "School",
    devices: 4,
    coordinates: [21.6287162, 39.1232621],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 786
    }
  },
  {
    id: 70024,
    name: "Advanced Generations Schools (Nahdah) - Intermediate/Secondary Female",
    type: "School",
    devices: 2,
    coordinates: [21.6287162, 39.1232621],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate, Secondary",
      students: 626
    }
  },
  // MIS locations
  {
    id: 70028,
    name: "Al Moktashef International School (MIS) - Shatee",
    type: "School",
    devices: 6,
    coordinates: [21.6098382, 39.0712501],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 1202
    }
  },
  {
    id: 70029,
    name: "Al Moktashef International School (MIS) - Naeem",
    type: "School",
    devices: 2,
    coordinates: [21.6349667, 39.1310943],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 575
    }
  },
  {
    id: 70030,
    name: "Al Moktashef International School (MIS) - Downtown Male",
    type: "School",
    devices: 2,
    coordinates: [21.5550761, 39.1158886],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 536
    }
  },
  {
    id: 70031,
    name: "Al Moktashef International School (MIS) - Downtown Elementary",
    type: "School",
    devices: 3,
    coordinates: [21.5550761, 39.1158886],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 999
    }
  },
  {
    id: 70032,
    name: "Al Moktashef International School (MIS) - Downtown Female",
    type: "School",
    devices: 3,
    coordinates: [21.5550761, 39.1158886],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate, Secondary",
      students: 247
    }
  },
  {
    id: 70033,
    name: "Al Moktashef International School (MIS) - Mohammadiyah",
    type: "School",
    devices: 3,
    coordinates: [21.6394916, 39.1419534],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 1382
    }
  },
  // Other Jeddah schools
  {
    id: 70034,
    name: "JAIS (Zahra)",
    type: "School",
    devices: 1,
    coordinates: [21.6052059, 39.1262851],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 199
    }
  },
  {
    id: 70035,
    name: "JUS (A)",
    type: "School",
    devices: 2,
    coordinates: [21.598425, 39.1220898],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 243
    }
  },
  {
    id: 70036,
    name: "JUS (B)",
    type: "School",
    devices: 2,
    coordinates: [21.605024, 39.1560043],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate, Secondary",
      students: 204
    }
  },
  // Al-Motaqadmiah Schools (Zahra)
  {
    id: 70043,
    name: "Al-Motaqadmiah Schools (Zahra) - Male",
    type: "School",
    devices: 1,
    coordinates: [21.5952894, 39.1356014],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary, Intermediate, Secondary",
      students: 71
    }
  },
  {
    id: 70044,
    name: "Al-Motaqadmiah Schools (Zahra) - Female",
    type: "School",
    devices: 2,
    coordinates: [21.5952894, 39.1356014],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Elementary, Intermediate, Secondary",
      students: 125
    }
  },
  // Dar Al Hanan Schools (Zahra)
  {
    id: 70045,
    name: "Dar Al Hanan Schools (Zahra) - Elementary",
    type: "School",
    devices: 2,
    coordinates: [21.6035705, 39.1357902],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-12",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary",
      students: 240
    }
  },
  {
    id: 70046,
    name: "Dar Al Hanan Schools (Zahra) - Secondary",
    type: "School",
    devices: 1,
    coordinates: [21.6035705, 39.1357902],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Female",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Intermediate, Secondary",
      students: 216
    }
  },
  // Final Jeddah schools
  {
    id: 70054,
    name: "Alhamraa International Schools",
    type: "School",
    devices: 1,
    coordinates: [21.5099113, 39.1667377],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 397
    }
  },
  {
    id: 70055,
    name: "Alfaisalyyah Schools",
    type: "School",
    devices: 3,
    coordinates: [21.5533924, 39.1766974],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "12-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Intermediate, Secondary",
      students: 410
    }
  },
  {
    id: 70056,
    name: "Alyaqoot",
    type: "School",
    devices: 1,
    coordinates: [21.7900734, 39.0793184],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "15-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "National",
      level: "Secondary",
      students: 496
    }
  },
  {
    id: 70057,
    name: "Dar Al-thikr",
    type: "School",
    devices: 2,
    coordinates: [21.6240862, 39.1456664],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 2053
    }
  },
  {
    id: 70058,
    name: "Jeddah International School",
    type: "School",
    devices: 1,
    coordinates: [21.5601459, 39.1321866],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Male",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 1087
    }
  },
  {
    id: 70060,
    name: "Waad Academy",
    type: "School",
    devices: 2,
    coordinates: [21.7971782, 39.1014692],
    region: "Jeddah",
    mediaOwner: "Waki",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Mixed",
    ageRange: "6-18",
    orientation: "Portrait",
    segment: "Education",
    details: {
      schoolType: "International",
      level: "Elementary, Intermediate, Secondary",
      students: 1621
    }
  }
];
